import { FlowchartCompleteStruct } from "./flowchart-complete.struct";

export class ProtocolCompleteStruct {
    public idProtocol: number;
    public protocolName: string;
    public protocolDescription: string;
    public datetimeInclusion: Date;
    public listFlowchart: FlowchartCompleteStruct[];
}